(function handleProductView() {
  /**
   * @param {string} storageKey - localStorage key
   * @param {string} selector - JSON script selector
   */
  function updateRecentlyViewedStore(storageKey, selector) {
    const storage = localStorage.getItem(storageKey);
    const store = storage !== null ? JSON.parse(storage) : {};
    const current = JSON.parse(document.querySelector(selector)?.textContent || '{}');
    const key = Object.keys(current)[0];

    if (!key || !current[key]) return;

    if (Object.keys(store).length > 7) {
      delete store[Object.keys(store)[0]];
    }

    store[key] = current[key];

    localStorage.setItem(storageKey, JSON.stringify(store));
  }

  updateRecentlyViewedStore('recently-viewed', '[data-product-card-json]');
  updateRecentlyViewedStore('recently-viewed-compact', '[data-product-card-compact-json]');
})();
